import Vue from "vue";

class DynamicFormService {
  ObterGrid(pagina) {
    return Vue.prototype.$http({
      url: "dynamic-question/get-grid/" + pagina + "/20",
      method: "GET"
    });
  }

  Obter(id) {
    return Vue.prototype.$http({
      url: "dynamic-question/get/" + id,
      method: "GET"
    });
  }

  Novo(viewModel) {
    return Vue.prototype.$http({
      url: "dynamic-question/new",
      data: viewModel,
      method: "POST"
    });
  }

  Editar(viewModel) {
    return Vue.prototype.$http({
      url: "dynamic-question/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  Remover(id) {
    return Vue.prototype.$http({
      url: "dynamic-question/remove/" + id,
      method: "DELETE"
    });
  }

  ObterTodas(isGaau) {
    const query = isGaau !== undefined && isGaau !== null ? "?isGaau=" + isGaau : "";
    return Vue.prototype.$http({
      url: "dynamic-question/get-all" + query,
      method: "GET"
    });
  }

  ObterRespostasPorGaau(gaauId) {
    return Vue.prototype.$http({
      url: "dynamic-question/answers/by-gaau/" + gaauId,
      method: "GET"
    });
  }

  ObterRespostasPorInventario(inventoryId) {
    return Vue.prototype.$http({
      url: "dynamic-question/answers/by-inventory/" + inventoryId,
      method: "GET"
    });
  }

  SalvarRespostas(payload) {
    return Vue.prototype.$http({
      url: "dynamic-question/answers/save",
      data: payload,
      method: "POST"
    });
  }
}

export default new DynamicFormService();
